<template>
  <v-container fluid grid-list-md fill-height>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          
          <v-flex xs12 sm6 md1>
            <router-link to="/Dashboard">
              <v-btn icon dark >
                <v-icon>keyboard_backspace</v-icon>
              </v-btn>
            </router-link>
          </v-flex>

          <v-flex xs12 sm6 md1>
            <h2>
              GSTR-3
            </h2>
          </v-flex>
          
          <v-flex xs12 sm6 md1>
          </v-flex>
          
          <v-flex xs12 sm6 md4>
            <v-select
              class="select-firm"
              dense
              flat
              clearable
              item-text="name"
              return-object
              :items="firmsByBrand"
              label="Select Firm"
              v-model="selectedFirm"
            ></v-select>
          </v-flex>

          <v-flex xs12 sm6 md1>
          </v-flex>
          
          <v-flex xs12 sm3 md2>
            <v-menu
              :close-on-content-click="false"
              v-model="datepickerFrom"
              :nudge-right="40"
              class="ist-datepicker"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="fromDate" @input="datepickerFrom = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6 md1>
          </v-flex>
          <v-flex xs12 sm3 md2>
            <v-menu
              :close-on-content-click="false"
              v-model="datepickerTo"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              class="ist-datepicker"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="toDate"
                label="To Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="toDate" @input="datepickerTo = false"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-toolbar>
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm3 md3>
                  <template v-if="selectedFirm">
                  Firm name :
                  <b>{{selectedFirm.name}}</b>
                  <br />Address :
                  <b>{{generateAddress(selectedFirm)}}</b>
                  <br />
                  GSTIN :
                  <b>{{selectedFirm.GST_number}}</b>
                  <br />Mobile :
                  <b>{{selectedFirm.mobileNumber}}</b>
                  <br />Email :
                  <b>{{selectedFirm.email}}</b>
                  <br/>
                </template>
                </v-flex>
                <v-flex xs12 sm8 md8  style="overflow-x: auto;">
                  <table class="fl-table">
                  <thead>
                    <tr>
                  <th>Expand</th>
                  <th>Description</th>
                  <th>Total Taxable Value</th>
                  <th colspan="4">TAX/GST Amounts</th>
                  <th>Total Invoices</th>
                </tr>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th>IGST A.</th>
                  <th>CGST A.</th>
                  <th>SGST A.</th>
                  <th>CESS</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><v-icon v-if="!outwardSupplies.expand" @click="toggle(outwardSupplies)" color="primary">expand_more</v-icon>
                  <v-icon v-if="outwardSupplies.expand" @click="toggle(outwardSupplies)" color="primary">expand_less</v-icon></td>
                  <td>
                    <h2>OUTWARD SUPPLIES</h2>
                  </td>
                  <td>{{outwardSupplies.totalBaseAmount || 0 | amount}}</td>
                  <td>{{outwardSupplies.IGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.CGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.SGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.CESS || 0 | amount}}</td>
                  <td>{{outwardSupplies.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                 <tr v-if="outwardSupplies.expand">
                 <td></td>
                  <td>
                    <h2 class="primary--text"> <b>(A). Intra state </b></h2>
                  </td>
                  <td>{{outwardSupplies.intraState.totalBaseAmount || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.IGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.CGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.SGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.CESS || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                <tr v-if="outwardSupplies.expand">
                 <td>
                        <v-icon
                          v-if="!outwardSupplies.intraState.taxable.expand"
                          @click="toggle(outwardSupplies.intraState.taxable)"
                          color="primary"
                        >expand_more</v-icon>
                        <v-icon
                          v-if="outwardSupplies.intraState.taxable.expand"
                          @click="toggle(outwardSupplies.intraState.taxable)"
                          color="primary"
                        >expand_less</v-icon>
                      </td>
                  <td>
                    <h4>(i). Taxable</h4>
                  </td>
                  <td>{{outwardSupplies.intraState.taxable.totalBaseAmount || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.taxable.IGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.taxable.CGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.taxable.SGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.taxable.CESS || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.taxable.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                       <template v-if="outwardSupplies.intraState.taxable.expand">
                    <tr>
                      <td></td>
                      <td>
                        <h4>GST (3%)</h4>
                      </td>
                      <td>{{outwardSupplies.intraState.taxable.GST_3.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_3.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_3.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_3.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_3.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_3.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (5%)</h4>
                      </td>
                      <td>{{outwardSupplies.intraState.taxable.GST_5.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_5.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_5.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_5.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_5.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_5.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (12%)</h4>
                      </td>
                      <td>{{outwardSupplies.intraState.taxable.GST_12.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_12.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_12.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_12.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_12.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_12.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (18%)</h4>
                      </td>
                      <td>{{outwardSupplies.intraState.taxable.GST_18.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_18.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_18.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_18.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_18.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_18.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (28%)</h4>
                      </td>
                      <td>{{outwardSupplies.intraState.taxable.GST_28.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_28.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_28.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_28.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_28.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.intraState.taxable.GST_28.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                    </template>
                 <tr v-if="outwardSupplies.expand">
                  <td></td>
                  <td>
                    <h4>(ii). Exempted</h4>
                  </td>
                  <td>{{outwardSupplies.intraState.exempted.totalBaseAmount || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.exempted.IGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.exempted.CGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.exempted.SGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.exempted.CESS || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.exempted.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                 <tr v-if="outwardSupplies.expand">
                  <td></td>
                  <td>
                    <h4>(iii). Nill Rated</h4>
                  </td>
                  <td>{{outwardSupplies.intraState.nillrated.totalBaseAmount || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.nillrated.IGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.nillrated.CGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.nillrated.SGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.nillrated.CESS || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.nillrated.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                 <tr v-if="outwardSupplies.expand">
                  <td></td>
                  <td>
                    <h4>(iv). Others</h4>
                  </td>
                  <td>{{outwardSupplies.intraState.others.totalBaseAmount || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.others.IGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.others.CGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.others.SGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.others.CESS || 0 | amount}}</td>
                  <td>{{outwardSupplies.intraState.others.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                 <tr v-if="outwardSupplies.expand">
                  <td></td>
                  <td>
                    <h2 class="primary--text"> <b> (B). Inter state </b></h2>
                  </td>
                  <td>{{outwardSupplies.interState.totalBaseAmount || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.IGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.CGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.SGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.CESS || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                <tr v-if="outwardSupplies.expand">
                          <td>
                        <v-icon
                          v-if="!outwardSupplies.interState.taxable.expand"
                          @click="toggle(outwardSupplies.interState.taxable)"
                          color="primary"
                        >expand_more</v-icon>
                        <v-icon
                          v-if="outwardSupplies.interState.taxable.expand"
                          @click="toggle(outwardSupplies.interState.taxable)"
                          color="primary"
                        >expand_less</v-icon>
                      </td>
                  <td>
                    <h4>(i). Taxable</h4>
                  </td>
                  <td>{{outwardSupplies.interState.taxable.totalBaseAmount || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.taxable.IGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.taxable.CGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.taxable.SGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.taxable.CESS || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.taxable.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                      <template v-if="outwardSupplies.interState.taxable.expand">
                    <tr>
                      <td></td>
                      <td>
                        <h4>GST (3%)</h4>
                      </td>
                      <td>{{outwardSupplies.interState.taxable.GST_3.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_3.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_3.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_3.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_3.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_3.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (5%)</h4>
                      </td>
                      <td>{{outwardSupplies.interState.taxable.GST_5.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_5.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_5.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_5.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_5.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_5.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (12%)</h4>
                      </td>
                      <td>{{outwardSupplies.interState.taxable.GST_12.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_12.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_12.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_12.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_12.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_12.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (18%)</h4>
                      </td>
                      <td>{{outwardSupplies.interState.taxable.GST_18.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_18.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_18.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_18.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_18.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_18.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (28%)</h4>
                      </td>
                      <td>{{outwardSupplies.interState.taxable.GST_28.totalBaseAmount || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_28.IGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_28.CGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_28.SGST || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_28.CESS || 0 | amount}}</td>
                      <td>{{outwardSupplies.interState.taxable.GST_28.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                    </template>
                 <tr v-if="outwardSupplies.expand">
                  <td></td>
                  <td>
                    <h4>(ii). Exempted</h4>
                  </td>
                  <td>{{outwardSupplies.interState.exempted.totalBaseAmount || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.exempted.IGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.exempted.CGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.exempted.SGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.exempted.CESS || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.exempted.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                 <tr v-if="outwardSupplies.expand">
                  <td></td>
                  <td>
                    <h4>(iii). Nill Rated</h4>
                  </td>
                  <td>{{outwardSupplies.interState.nillrated.totalBaseAmount || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.nillrated.IGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.nillrated.CGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.nillrated.SGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.nillrated.CESS || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.nillrated.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                 <tr v-if="outwardSupplies.expand">
                  <td></td>
                  <td>
                    <h4>(iv). Others</h4>
                  </td>
                  <td>{{outwardSupplies.interState.others.totalBaseAmount || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.others.IGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.others.CGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.others.SGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.others.CESS || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.others.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                <template v-if="inwardSupplies && inwardSupplies.hasOwnProperty('expand')">
                <tr>
                  <td><v-icon v-if="!inwardSupplies.expand" @click="toggle(inwardSupplies)" color="primary">expand_more</v-icon>
                  <v-icon v-if="inwardSupplies.expand" @click="toggle(inwardSupplies)" color="primary">expand_less</v-icon></td>
                  <td>
                    <h2>INWARD SUPPLIES</h2>
                  </td>
                  <td>{{inwardSupplies.totalBaseAmount || 0 | amount}}</td>
                  <td>{{inwardSupplies.IGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.CGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.SGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.CESS || 0 | amount}}</td>
                  <td>{{inwardSupplies.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                        <tr v-if="inwardSupplies.expand">
                         <td></td>
                  <td>
                    <h3>(A). Intra state</h3>
                  </td>
                  <td>{{inwardSupplies.intraState.totalBaseAmount || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.IGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.CGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.SGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.CESS || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                <tr v-if="inwardSupplies.expand">
                 <td>
                        <v-icon
                          v-if="!inwardSupplies.intraState.taxable.expand"
                          @click="toggle(inwardSupplies.intraState.taxable)"
                          color="primary"
                        >expand_more</v-icon>
                        <v-icon
                          v-if="inwardSupplies.intraState.taxable.expand"
                          @click="toggle(inwardSupplies.intraState.taxable)"
                          color="primary"
                        >expand_less</v-icon>
                      </td>
                      <td>
                    <h4>(i). Taxable</h4>
                  </td>
                  <td>{{inwardSupplies.intraState.taxable.totalBaseAmount || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.taxable.IGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.taxable.CGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.taxable.SGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.taxable.CESS || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.taxable.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                  <template v-if="inwardSupplies.intraState.taxable.expand">
                    <tr>
                      <td></td>
                      <td>
                        <h4>GST (3%)</h4>
                      </td>
                      <td>{{inwardSupplies.intraState.taxable.GST_3.totalBaseAmount || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_3.IGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_3.CGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_3.SGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_3.CESS || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_3.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (5%)</h4>
                      </td>
                      <td>{{inwardSupplies.intraState.taxable.GST_5.totalBaseAmount || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_5.IGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_5.CGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_5.SGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_5.CESS || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_5.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (12%)</h4>
                      </td>
                      <td>{{inwardSupplies.intraState.taxable.GST_12.totalBaseAmount || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_12.IGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_12.CGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_12.SGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_12.CESS || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_12.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (18%)</h4>
                      </td>
                      <td>{{inwardSupplies.intraState.taxable.GST_18.totalBaseAmount || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_18.IGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_18.CGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_18.SGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_18.CESS || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_18.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (28%)</h4>
                      </td>
                      <td>{{inwardSupplies.intraState.taxable.GST_28.totalBaseAmount || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_28.IGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_28.CGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_28.SGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_28.CESS || 0 | amount}}</td>
                      <td>{{inwardSupplies.intraState.taxable.GST_28.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                    </template>
                 <tr v-if="inwardSupplies.expand">
                  <td></td>
                  <td>
                    <h4>(ii). Exempted</h4>
                  </td>
                  <td>{{inwardSupplies.intraState.exempted.totalBaseAmount || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.exempted.IGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.exempted.CGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.exempted.SGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.exempted.CESS || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.exempted.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                 <tr v-if="inwardSupplies.expand">
                  <td></td>
                  <td>
                    <h4>(iii). Nill Rated</h4>
                  </td>
                  <td>{{inwardSupplies.intraState.nillrated.totalBaseAmount || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.nillrated.IGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.nillrated.CGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.nillrated.SGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.nillrated.CESS || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.nillrated.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                 <tr v-if="inwardSupplies.expand">
                  <td></td>
                  <td>
                    <h4>(iv). Others</h4>
                  </td>
                  <td>{{inwardSupplies.intraState.others.totalBaseAmount || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.others.IGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.others.CGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.others.SGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.others.CESS || 0 | amount}}</td>
                  <td>{{inwardSupplies.intraState.others.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                 <tr v-if="inwardSupplies.expand">
                  <td></td>
                  <td>
                    <h3>(A). Inter state</h3>
                  </td>
                  <td>{{inwardSupplies.interState.totalBaseAmount || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.IGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.CGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.SGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.CESS || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                <tr v-if="inwardSupplies.expand">
                     <td>
                        <v-icon
                          v-if="!inwardSupplies.interState.taxable.expand"
                          @click="toggle(inwardSupplies.interState.taxable)"
                          color="primary"
                        >expand_more</v-icon>
                        <v-icon
                          v-if="inwardSupplies.interState.taxable.expand"
                          @click="toggle(inwardSupplies.interState.taxable)"
                          color="primary"
                        >expand_less</v-icon>
                      </td>
                  <td>
                    <h4>(i). Taxable</h4>
                  </td>
                  <td>{{inwardSupplies.interState.taxable.totalBaseAmount || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.taxable.IGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.taxable.CGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.taxable.SGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.taxable.CESS || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.taxable.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                  <template v-if="inwardSupplies.interState.taxable.expand">
                    <tr>
                      <td></td>
                      <td>
                        <h4>GST (3%)</h4>
                      </td>
                      <td>{{inwardSupplies.interState.taxable.GST_3.totalBaseAmount || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_3.IGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_3.CGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_3.SGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_3.CESS || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_3.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (5%)</h4>
                      </td>
                      <td>{{inwardSupplies.interState.taxable.GST_5.totalBaseAmount || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_5.IGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_5.CGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_5.SGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_5.CESS || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_5.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (12%)</h4>
                      </td>
                      <td>{{inwardSupplies.interState.taxable.GST_12.totalBaseAmount || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_12.IGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_12.CGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_12.SGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_12.CESS || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_12.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (18%)</h4>
                      </td>
                      <td>{{inwardSupplies.interState.taxable.GST_18.totalBaseAmount || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_18.IGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_18.CGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_18.SGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_18.CESS || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_18.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                      <tr>
                      <td></td>
                      <td>
                        <h4>GST (28%)</h4>
                      </td>
                      <td>{{inwardSupplies.interState.taxable.GST_28.totalBaseAmount || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_28.IGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_28.CGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_28.SGST || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_28.CESS || 0 | amount}}</td>
                      <td>{{inwardSupplies.interState.taxable.GST_28.totalInvoiceAmount || 0 | amount}}</td>
                    </tr>
                    </template>
                 <tr v-if="inwardSupplies.expand">
                  <td></td>
                  <td>
                    <h4>(ii). Exempted</h4>
                  </td>
                  <td>{{inwardSupplies.interState.exempted.totalBaseAmount || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.exempted.IGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.exempted.CGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.exempted.SGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.exempted.CESS || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.exempted.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                 <tr v-if="inwardSupplies.expand">
                  <td></td>
                  <td>
                    <h4>(iii). Nill Rated</h4>
                  </td>
                  <td>{{inwardSupplies.interState.nillrated.totalBaseAmount || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.nillrated.IGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.nillrated.CGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.nillrated.SGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.nillrated.CESS || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.nillrated.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                 <tr v-if="inwardSupplies.expand">
                  <td></td>
                  <td>
                    <h4>(iv). Others</h4>
                  </td>
                  <td>{{inwardSupplies.interState.others.totalBaseAmount || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.others.IGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.others.CGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.others.SGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.others.CESS || 0 | amount}}</td>
                  <td>{{inwardSupplies.interState.others.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                </template>
              </tbody>
              </table>
              </v-flex>
              <v-flex xs12 sm1 md1>
                <br/>
                <v-btn round class="primary white--text" flat type="button" @click="onexport()">
                  Excel
                    <v-icon dark> save_alt </v-icon>
                </v-btn>
                <v-spacer/>
                <br/>
                <v-btn round class="primary white--text" flat type="button" @click="printGST3()">
                  Print
                <v-icon dark> print </v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-layout row wrap>
          <v-flex xs12 style="overflow-x: auto;">
           <table class="fl-table">
              <thead>
                <tr>
                  <th>S. No</th>
                  <th>Expand</th>
                  <th>Description</th>
                  <th>Place of Supply</th>
                  <th>Total Taxable Value</th>
                  <th colspan="4">TAX/GST Amounts</th>
                  <th>Total Invoices</th>
                </tr>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th>IGST A.</th>
                  <th>CGST A.</th>
                  <th>SGST A.</th>
                  <th>CESS</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td >3.1</td>
                  <td><v-icon v-if="!tab2.row_3_1_expand.expand" @click="toggle(tab2.row_3_1_expand)" color="primary">expand_more</v-icon>
                  <v-icon v-if="tab2.row_3_1_expand.expand" @click="toggle(tab2.row_3_1_expand)" color="primary">expand_less</v-icon></td>
                  <td>
                    <h2>OUTWARD Supplies & INWARD SUPPLIES liable to reverse charge</h2>
                  </td>
                  <td></td>
                  <!-- <td>{{inwardSupplies.totalBaseAmount + outwardSupplies.totalBaseAmount || 0 | amount}}</td> -->
                  <td>{{ outwardSupplies.totalBaseAmount || 0 | amount}}</td>
                  <td>{{ outwardSupplies.IGST || 0 | amount}}</td>
                  <td>{{ outwardSupplies.CGST || 0 | amount}}</td>
                  <td>{{ outwardSupplies.SGST || 0 | amount}}</td>
                  <td>{{ outwardSupplies.CESS || 0 | amount}}</td>
                  <td>{{ outwardSupplies.totalInvoiceAmount || 0 | amount}}</td>
                </tr> 
                <tr v-if="tab2.row_3_1_expand.expand">
                  <td></td>
                  <td></td>
                  <td>
                    <h3>(A). Outward Taxable Supplies</h3>Taxable
                  </td>
                  <td></td>
                  <td>{{outwardSupplies.interState.taxable.totalBaseAmount + outwardSupplies.intraState.taxable.totalBaseAmount || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.taxable.IGST + outwardSupplies.intraState.taxable.IGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.taxable.CGST + outwardSupplies.intraState.taxable.CGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.taxable.SGST + outwardSupplies.intraState.taxable.SGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.taxable.CESS + outwardSupplies.intraState.taxable.CESS || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.taxable.totalInvoiceAmount + outwardSupplies.intraState.taxable.totalInvoiceAmount || 0 | amount}}</td>
                </tr> 
                <tr v-if="tab2.row_3_1_expand.expand">
                  <td></td>
                  <td></td>
                  <td>
                    <h3>(B). Outward Taxable Supplies</h3>Zero Rated
                  </td>
                  <td></td>
                  <td>{{outwardSupplies.interState.nillrated.totalBaseAmount + outwardSupplies.intraState.nillrated.totalBaseAmount || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.nillrated.IGST + outwardSupplies.intraState.nillrated.IGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.nillrated.CGST + outwardSupplies.intraState.nillrated.CGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.nillrated.SGST + outwardSupplies.intraState.nillrated.SGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.nillrated.CESS + outwardSupplies.intraState.nillrated.CESS || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.nillrated.totalInvoiceAmount + outwardSupplies.intraState.nillrated.totalInvoiceAmount || 0 | amount}}</td>
                </tr>
                <tr v-if="tab2.row_3_1_expand.expand">
                  <td></td>
                  <td></td>
                  <td>
                    <h3>(C). Outward Taxable Supplies</h3>Nill Rated or Exempt
                  </td>
                  <td></td>
                  <td>{{outwardSupplies.interState.exempted.totalBaseAmount + outwardSupplies.intraState.exempted.totalBaseAmount || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.exempted.IGST + outwardSupplies.intraState.exempted.IGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.exempted.CGST + outwardSupplies.intraState.exempted.CGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.exempted.SGST + outwardSupplies.intraState.exempted.SGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.exempted.CESS + outwardSupplies.intraState.exempted.CESS || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.exempted.totalInvoiceAmount + outwardSupplies.intraState.exempted.totalInvoiceAmount || 0 | amount}}</td>
                </tr> 
                <tr v-if="tab2.row_3_1_expand.expand">
                  <td></td>
                  <td></td>
                  <td>
                    <h3>(D). Inward Taxable Supplies</h3>Liable To Reverse Charge
                  </td>
                  <td></td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr> 
                <tr v-if="tab2.row_3_1_expand.expand">
                  <td></td>
                  <td></td>
                  <td>
                    <h3>(E). NON-GST Outward Supplies</h3>
                  </td>
                  <td>-</td>
                  <td>{{outwardSupplies.interState.others.totalBaseAmount + outwardSupplies.intraState.others.totalBaseAmount || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.others.IGST + outwardSupplies.intraState.others.IGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.others.CGST + outwardSupplies.intraState.others.CGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.others.SGST + outwardSupplies.intraState.others.SGST || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.others.CESS + outwardSupplies.intraState.others.CESS || 0 | amount}}</td>
                  <td>{{outwardSupplies.interState.others.totalInvoiceAmount + outwardSupplies.intraState.others.totalInvoiceAmount || 0 | amount}}</td>
                </tr> 
                <tr>
                  <td>3.2</td>
                  <td></td>
                  <td>
                    <h2>INTER-STATE Supplies Made To Understand Composition Taxable Persons...</h2>
                  </td>
                  <td></td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr> 
                 <tr>
                  <td>4</td>
                  <td><v-icon v-if="!tab2.row_4_expand.expand" @click="toggle(tab2.row_4_expand)" color="primary">expand_more</v-icon>
                  <v-icon v-if="tab2.row_4_expand.expand" @click="toggle(tab2.row_4_expand)" color="primary">expand_less</v-icon></td>
                  <td>
                    <h2>ELIGIABLE ITC</h2>
                  </td>
                  <td></td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr> 
                <tr v-if="tab2.row_4_expand.expand">
                  <td></td>
                  <td></td>
                  <td>
                    <h3>(A). ITC Available [Full/Part]</h3>
                  </td>
                  <td></td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr> 
                <tr v-if="tab2.row_4_expand.expand">
                  <td></td>
                  <td></td>
                  <td>
                    <h4>(i). Imports of Goods</h4>
                  </td>
                  <td></td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr> 
                 <tr v-if="tab2.row_4_expand.expand">
                  <td></td>
                  <td></td>
                  <td>
                    <h4>(ii). Imports of Services</h4>
                  </td>
                  <td></td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr> 
                 <tr v-if="tab2.row_4_expand.expand">
                  <td></td>
                  <td></td>
                  <td>
                    <h4>(iii). Inward Supplies Liable</h4>
                    <h4>To reverse charges</h4>
                  </td>
                  <td></td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr> 
                 <tr v-if="tab2.row_4_expand.expand">
                  <td></td>
                  <td></td>
                  <td>
                    <h4>(iv). Inward Supplies From ISD</h4>
                  </td>
                  <td></td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr> 
                 <tr v-if="tab2.row_4_expand.expand">
                  <td></td>
                  <td></td>
                  <td>
                    <h4>(v). All Other ITC</h4>
                  </td>
                  <td></td>
                  <td>{{inwardSupplies.totalBaseAmount || 0 | amount}}</td>
                  <td>{{inwardSupplies.IGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.CGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.SGST || 0 | amount}}</td>
                  <td>{{inwardSupplies.CESS || 0 | amount}}</td>
                  <td>{{inwardSupplies.totalInvoiceAmount || 0 | amount}}</td>
                </tr> 
                <tr v-if="tab2.row_4_expand.expand">
                  <td></td>
                  <td></td>
                  <td>
                    <h3>(B). ITC Reserved</h3>
                  </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr> 
                <tr v-if="tab2.row_4_expand.expand">
                  <td></td>
                  <td></td>
                  <td>
                    <h4>(i). As per Rules 42 & 43</h4>
                    <h4>of cost</h4>
                  </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr> 
                <tr v-if="tab2.row_4_expand.expand">
                  <td></td>
                  <td></td>
                  <td>
                    <h4>(ii). Others</h4>
                  </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr> 
                <tr v-if="tab2.row_4_expand.expand">
                  <td></td>
                  <td></td>
                  <td>
                    <h3>(C). Net ITC Available</h3>
                    <h3>(A) - (B)</h3>
                  </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr> 
                <tr v-if="tab2.row_4_expand.expand">
                  <td></td>
                  <td></td>
                  <td>
                    <h3>(D). InEligible ITC</h3>
                 
                  </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr> 
                <tr v-if="tab2.row_4_expand.expand">
                  <td></td>
                  <td></td>
                  <td>
                    <h4>(i). As per Section 17(s)</h4>
                  </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr> 
                <tr v-if="tab2.row_4_expand.expand">
                  <td></td>
                  <td></td>
                  <td>
                    <h4>(ii). Others</h4>
                  </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr> 
                 <tr>
                  <td>5</td>
                  <td><v-icon v-if="!tab2.row_5_expand.expand" @click="toggle(tab2.row_5_expand)" color="primary">expand_more</v-icon>
                  <v-icon v-if="tab2.row_5_expand.expand" @click="toggle(tab2.row_5_expand)" color="primary">expand_less</v-icon></td>
                  <td>
                    <h2>Values Of Exempted Nill rated & NON-GST Inward Supplies</h2>
                  </td>
                  <td></td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr> 
                <tr v-if="tab2.row_5_expand.expand">
                  <td></td>
                  <td></td>
                  <td>
                    <h3>(A). From Supplier Under</h3>
                    <h3>Composition Scheme, Exempt</h3>
                    <h3>& Nillrated Supplies</h3>
                  </td>
                  <td></td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr> 
                <tr v-if="tab2.row_5_expand.expand">
                  <td></td>
                  <td></td>
                  <td>
                    <h3>(B). Non-GST Supplies</h3>
                  </td>
                  <td></td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr> 
              </tbody>
            </table> 
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container> 
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import { convertToPDFGST_3 } from "../../utils/pdfmake";
import { convertToExcelGST_3 } from "../../utils/excelExport";

import XLSX from 'xlsx'
export default {
  data() {
    return {
      selectedFirm: null,
      toDate: null,
      fromDate: null,
      datepickerFrom: null,
      datepickerTo: null,
      inwardSupplies: {},
      outwardSupplies: {},
      tab2:{
        row_3_1_expand : {expand : false},
        row_4_expand : {expand : false},
        row_5_expand : {expand : false},
      },
    };
  },
  created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("buyer", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("seller", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.reset('inwardSupplies')
    this.reset('outwardSupplies')
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand"]),
    firmsByBrand1() {
      return this.firms.filter(item => item["brand"] === this.selectedBrand);
    },
    // current brands firm list
    firmsByBrand () {
        // return selected brand firms
        let firmsB = this.firms
          .filter((item) => item['brand'] === this.selectedBrand)
          firmsB.map((item) => {
            if (item.defaultFirm) {
              this.selectedFirm = item;
            }
          })
        return firmsB;
    },
  },
  methods: {
    toggle(item){
      item.expand = !item.expand;
    },

    calculateGSTInvoice(currentUser, invoice) {
      let SGST_val = 0;
      let CGST_val = 0;
      let IGST_val = 0;
      invoice && invoice.items && invoice.items.map((item, index) => {
        SGST_val += parseFloat(item["SGST_val"]);
        CGST_val += parseFloat(item["CGST_val"]);
        IGST_val += parseFloat(item["IGST_val"]);
      });
      return { SGST_val, CGST_val, IGST_val };
    },
    reset(obj) {
    this[obj] = {
        totalBaseAmount: 0,
        IGST: 0,
        CGST: 0,
        SGST: 0,
        CESS: 0,
        totalInvoiceAmount: 0,
        expand:false,
        intraState: {
          totalBaseAmount: 0,
          IGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoiceAmount: 0,
          taxable : {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0,
             expand: false,
            GST_3: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_5: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_12: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_18: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_28: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            }
          },
          exempted : {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0,
          },
          nillrated : {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0,
          },
          others : {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0,
          }
        },
        interState: {
          totalBaseAmount: 0,
          IGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoiceAmount: 0,
          taxable : {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0,
             expand: false,
            GST_3: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_5: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_12: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_18: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_28: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            }
          },
          exempted : {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0,
          },
          nillrated : {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0,
          },
          others : {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0,
          }
        }
      }
    },
    getGSTtotal(item) {
      let GSTTotal = 0;
      item &&
        item.items &&
        item.items.map(item => {
          GSTTotal += Number.parseFloat(item.GSTValue);
        });
      return GSTTotal;
    },
    getInvoice() {
      let invoiceOfFirm = this.invoices.filter(item => {
        return (
          item["brand"] === this.selectedBrand &&
          ( this.selectedFirm ? this.selectedFirm[".key"] === item["firm"] : true)
        );
      });
      this.reset('inwardSupplies')
      this.reset('outwardSupplies')
      let toDate = this.toDate ?  new Date(this.toDate).getTime() : null;
      let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
        invoiceOfFirm.map(invoice => {
          if (!invoice.return && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true)) {
            let gst = this.getGSTtotal(invoice);
            let buyer = null;
            if(invoice.isBuyer) {
              buyer = this.buyer[invoice.buyerId];
            } else {
              buyer = this.seller[invoice.buyerId];
            }
            let gstType = this.calculateGSTInvoice(buyer, invoice);
            if(invoice.isBuyer) {
              this.outwardSupplies.totalBaseAmount += parseFloat(invoice.totalAmount) - gst;
              this.outwardSupplies.totalInvoiceAmount += parseFloat(
              invoice.totalAmount);
              this.outwardSupplies.IGST += parseFloat(gstType["IGST_val"])
              this.outwardSupplies.CGST += parseFloat(gstType["CGST_val"])
              this.outwardSupplies.SGST += parseFloat(gstType["SGST_val"])
              if(buyer && this.selectedFirm.state == buyer.state) {
                this.calculateFromProduct('outwardSupplies','intraState',invoice.items,true);
              } else {
                this.calculateFromProduct('outwardSupplies','interState',invoice.items,false);
              }
            } else {
              this.inwardSupplies.totalBaseAmount += parseFloat(invoice.totalAmount) - gst;
              this.inwardSupplies.totalInvoiceAmount += parseFloat(
              invoice.totalAmount);
              this.inwardSupplies.IGST += parseFloat(gstType["IGST_val"])
              this.inwardSupplies.CGST += parseFloat(gstType["CGST_val"])
              this.inwardSupplies.SGST += parseFloat(gstType["SGST_val"])
              if(buyer && this.selectedFirm.state == buyer.state) {
                this.calculateFromProduct('inwardSupplies','intraState',invoice.items,true);
              } else {
                this.calculateFromProduct('inwardSupplies','interState',invoice.items,false);
              }
            }
          }
          });
    },
    printGST3(){
      let firm = this.selectedFirm;
      firm.address = this.generateAddress(firm);
      let doc = convertToPDFGST_3({
        firm : firm,
        inwardSupplies: this.inwardSupplies,
        outwardSupplies: this.outwardSupplies,
      });
      pdfMake.createPdf(doc).download();
    },
    onexport(){
      let firm = this.selectedFirm;
      firm.address = this.generateAddress(firm);
      let wb = convertToExcelGST_3({selectedFirm : firm,inwardSupplies:this.inwardSupplies,outwardSupplies:this.outwardSupplies})
      XLSX.writeFile(wb, 'GST3_'+new Date().getTime()+'.xlsx') // name of the file is 'book.xlsx'
    },
    generateAddress(user) {
      let address = "";
      if (user.block) {
        address = `${user.block}`;
      }
      if (user.village) {
        address = `${address ? address + ", " : ""}${user.village}`;
      }
      if (user.tehsil) {
        address = `${address ? address + ", " : ""}${user.tehsil}`;
      }
      if (user.state) {
        address = `${address ? address + ", " : ""}${user.state}`;
      }
      return address;
    },
    calculateFromProduct(type,subType,products,sameState){
      products && products.map((product)=>{
        switch(product.GST_type) {
          case 'EXEMPT' : {
            this[type][subType]['exempted'].totalBaseAmount += (parseFloat(product.basicPrice));
            this[type][subType]['exempted'].totalInvoiceAmount += (parseFloat(product.totlePrice));
            if(sameState) {
              this[type][subType]['exempted'].CGST += (parseFloat(product.GSTValue/2));
              this[type][subType]['exempted'].SGST += (parseFloat(product.GSTValue/2));
            } else {
              this[type][subType]['exempted'].IGST += (parseFloat(product.GSTValue));
            }
            break;
          };
          case 'NILL' : {
             this[type][subType]['nillrated'].totalBaseAmount += (parseFloat(product.basicPrice))
             this[type][subType]['nillrated'].totalInvoiceAmount += (parseFloat(product.totlePrice))
             if(sameState) {
              this[type][subType]['nillrated'].CGST += (parseFloat(product.GSTValue/2));
              this[type][subType]['nillrated'].SGST += (parseFloat(product.GSTValue/2));
            } else {
              this[type][subType]['nillrated'].IGST += (parseFloat(product.GSTValue));
            }
            break;
          };
          case 'TAXABLE' : {
             this[type][subType]['taxable'].totalBaseAmount += (parseFloat(product.basicPrice))
             this[type][subType]['taxable'].totalInvoiceAmount += (parseFloat(product.totlePrice))
             if(sameState) {
              this[type][subType]['taxable'].CGST += (parseFloat(product.GSTValue/2));
              this[type][subType]['taxable'].SGST += (parseFloat(product.GSTValue/2));
            } else {
              this[type][subType]['taxable'].IGST += (parseFloat(product.GSTValue));
            }
              switch (product.taxableGST_rate) {
                case 3: {
                  this[type][subType]["taxable"][
                    "GST_3"
                  ].totalBaseAmount += parseFloat(product.basicPrice);
                  this[type][subType]["taxable"][
                    "GST_3"
                  ].totalInvoiceAmount += parseFloat(product.totlePrice);
                  if (sameState) {
                    this[type][subType]["taxable"]["GST_3"].CGST += parseFloat(
                      product.GSTValue / 2
                    );
                    this[type][subType]["taxable"]["GST_3"].SGST += parseFloat(
                      product.GSTValue / 2
                    );
                  } else {
                    this[type][subType]["taxable"]["GST_3"].IGST += parseFloat(
                      product.GSTValue
                    );
                  }
                  break;
                }
                case 5: {
                  this[type][subType]["taxable"][
                    "GST_5"
                  ].totalBaseAmount += parseFloat(product.basicPrice);
                  this[type][subType]["taxable"][
                    "GST_5"
                  ].totalInvoiceAmount += parseFloat(product.totlePrice);
                  if (sameState) {
                    this[type][subType]["taxable"]["GST_5"].CGST += parseFloat(
                      product.GSTValue / 2
                    );
                    this[type][subType]["taxable"]["GST_5"].SGST += parseFloat(
                      product.GSTValue / 2
                    );
                  } else {
                    this[type][subType]["taxable"]["GST_5"].IGST += parseFloat(
                      product.GSTValue
                    );
                  }
                  break;
                }
                case 12: {
                  this[type][subType]["taxable"][
                    "GST_12"
                  ].totalBaseAmount += parseFloat(product.basicPrice);
                  this[type][subType]["taxable"][
                    "GST_12"
                  ].totalInvoiceAmount += parseFloat(product.totlePrice);
                  if (sameState) {
                    this[type][subType]["taxable"]["GST_12"].CGST += parseFloat(
                      product.GSTValue / 2
                    );
                    this[type][subType]["taxable"]["GST_12"].SGST += parseFloat(
                      product.GSTValue / 2
                    );
                  } else {
                    this[type][subType]["taxable"]["GST_12"].IGST += parseFloat(
                      product.GSTValue
                    );
                  }
                  break;
                }
                case 18: {
                  this[type][subType]["taxable"][
                    "GST_18"
                  ].totalBaseAmount += parseFloat(product.basicPrice);
                  this[type][subType]["taxable"][
                    "GST_18"
                  ].totalInvoiceAmount += parseFloat(product.totlePrice);
                  if (sameState) {
                    this[type][subType]["taxable"]["GST_18"].CGST += parseFloat(
                      product.GSTValue / 2
                    );
                    this[type][subType]["taxable"]["GST_18"].SGST += parseFloat(
                      product.GSTValue / 2
                    );
                  } else {
                    this[type][subType]["taxable"]["GST_18"].IGST += parseFloat(
                      product.GSTValue
                    );
                  }
                  break;
                }
                case 28: {
                  this[type][subType]["taxable"][
                    "GST_28"
                  ].totalBaseAmount += parseFloat(product.basicPrice);
                  this[type][subType]["taxable"][
                    "GST_28"
                  ].totalInvoiceAmount += parseFloat(product.totlePrice);
                  if (sameState) {
                    this[type][subType]["taxable"]["GST_28"].CGST += parseFloat(
                      product.GSTValue / 2
                    );
                    this[type][subType]["taxable"]["GST_28"].SGST += parseFloat(
                      product.GSTValue / 2
                    );
                  } else {
                    this[type][subType]["taxable"]["GST_28"].IGST += parseFloat(
                      product.GSTValue
                    );
                  }
                  break;
                }
              }
            break;
          };
          case 'OTHER' : {
             this[type][subType]['others'].totalBaseAmount += (parseFloat(product.basicPrice))
             this[type][subType]['others'].totalInvoiceAmount += (parseFloat(product.totlePrice))
             if(sameState) {
              this[type][subType]['others'].CGST += (parseFloat(product.GSTValue/2));
              this[type][subType]['others'].SGST += (parseFloat(product.GSTValue/2));
            } else {
              this[type][subType]['others'].IGST += (parseFloat(product.GSTValue));
            }
            break;
          };
        }
        this[type][subType].totalBaseAmount += (parseFloat(product.basicPrice))
        this[type][subType].totalInvoiceAmount += (parseFloat(product.totlePrice))
        if(sameState) {
          this[type][subType].CGST += (parseFloat(product.GSTValue/2));
          this[type][subType].SGST += (parseFloat(product.GSTValue/2));
        } else {
          this[type][subType].IGST += (parseFloat(product.GSTValue));
        }
      })
    }
  },
  watch: {
    selectedFirm(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.getInvoice();
        //this.setData();
      }
    },
    toDate(newVal, oldVal) {
      if (oldVal !== newVal && this.selectedFirm) {
        this.getInvoice();
        //this.setData();
      }
    },
    fromDate(newVal, oldVal) {
      if (oldVal !== newVal && this.selectedFirm) {
        this.getInvoice();
        // this.setData();
      }
    }
  }
};
</script>

<style >
.theme--light div.select-firm .v-icon {
  color: white;
}
.theme--light div.select-firm .v-label {
  color: white;
}
.theme--light div.select-firm .v-input__slot:before {
  border-color: white !important;
}
div.select-firm .v-select__selection--comma {
  color: white;
}

.disabledCard {
  background: lightgray;
}

.ist-datepicker .v-icon,
.ist-datepicker .v-label,
.ist-datepicker input {
  color: white !important;
}

.ist-datepicker .v-input__slot:before {
  border-color: white !important;
}

.fl-table {
  border-radius: 5px;
  font-size: 12px;
  font-weight: normal;
  border: none;
  border-collapse: collapse;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;
  background-color: white;
}

.fl-table td,
.fl-table th {
  text-align: center;
  padding: 8px;
}

.fl-table td {
  border: 1px solid #000000;
  font-size: 12px;
}

.fl-table thead th {
  color: #ffffff;
  background: #324960;
  border: 1px solid black;
}

.fl-table tr:nth-child(even) {
  background: #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// src/components/GSTReports/gst3.vue